<template>
    <Teleport to="body">
        <template v-for="reader in readers" :key="`nfhs-open-reader-${reader.id}`">
            <NfhsDigitalReaderWindow :reader="reader" />
        </template>
    </Teleport>
</template>

<script>
import { mapStores } from 'pinia'
import useMainStore from '@/stores/main'
import NfhsDigitalReaderWindow from '@/components/shared/NfhsDigitalReaderWindow.vue'
import { clampNfhsPanel, defaultMaximizedPanel, viewportSize } from '@/utils/nfhsDigital'

export default {
    name: 'NfhsDigitalFloatingWindow',
    components: {
        NfhsDigitalReaderWindow,
    },
    computed: {
        ...mapStores(useMainStore),
        readers() {
            return this.mainStore.nfhsDigital?.readers || []
        },
    },
    watch: {
        'mainStore.isLoggedIn'(loggedIn) {
            if (!loggedIn) {
                this.mainStore.closeNfhsDigitalSession()
            }
        },
    },
    mounted() {
        window.addEventListener('resize', this.clampAll)
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.clampAll)
    },
    methods: {
        clampAll() {
            const { vw, vh } = viewportSize()
            this.readers.forEach((reader) => {
                if (reader.maximized && !reader.collapsed) {
                    this.mainStore.patchNfhsDigitalReader(reader.id, defaultMaximizedPanel(vw, vh))
                    return
                }
                this.mainStore.patchNfhsDigitalReader(reader.id, clampNfhsPanel(reader, vw, vh))
            })
        },
    },
}
</script>
